import { map } from 'rambda';

import { TCollectionItem } from '../types';

export const getOptions = (collection: TCollectionItem[]) =>
  map(({ id, name }) => ({ text: name, value: id }), collection) as {
    text: string;
    value: string;
  }[];
